/* eslint-disable no-unused-vars */
/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import ModeEdit from '@mui/icons-material/ModeEdit';
import Delete from '@mui/icons-material/Delete';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Autocomplete from '@mui/material/Autocomplete';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useForm, Controller } from 'react-hook-form';
import { TransitionsModal } from '../../components/Modal';
import {
  useGetAllAdminQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
} from '../../services/userManagement';
import { useGetMerchantAllQuery } from '../../services/merchant';
import SortableTableLabel from '../../components/Table/SortableTableLabel';
import { ROLES } from '../../utils/constants';
import NotiAlert from '../../components/NotiAlert/NotiAlert';
import NotiAlertComfirmManageDel from '../../components/NotiAlert/NotiAlertComfirmDelManage';
import NotiAlertShowComp from '../../components/NotiAlert/NotiAlertShowComp';
import { useTranslation } from 'react-i18next';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function UserManagement() {
  const { t } = useTranslation();
  const columns = [
  { id: 'order', label: t('app.no'), minWidth: 100, sortable: false },
  { id: 'email', label: t('app.email'), minWidth: 100 },
  {
    id: 'role',
    label: t('app.role'),
    minWidth: 100,
    align: 'center',
  },
  {
    id: 'company',
    label: t('app.company'),
    minWidth: 150,
    align: 'center',
  },
  {
    id: 'action',
    label: t('app.edit'),
    minWidth: 100,
    align: 'center',
    sortable: false,
  },
];

  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [sortBy, setSortBy] = useState('createdAt');
  const [sortOrder, setSortOrder] = useState('desc');
  const [merchants, setMerchants] = useState([]);
  const [selectedEditId, setSelectedEditId] = useState(null);
  const [openNoti, setOpenNoti] = useState(false);
  const [openNotiComfirm, setOpenNotiComfirm] = useState(false);
  const [openComp, setOpenComp] = useState(false);
  const [id, setId] = useState('');
  const [title, setTitle] = useState('');
  const [notiValue, setNotiValue] = useState('');
  const [search, setSearch] = useState('');
  const [compList, setCompList] = useState([]);

  const {
    data: userLists,
    isLoading,
    refetch,
  } = useGetAllAdminQuery(
    {
      size: rowsPerPage,
      page: page === 0 ? 1 : page + 1,
      search,
      sortBy,
      sortOrder,
    },
    {
      pollingInterval: 30000,
      refetchOnMountOrArgChange: true,
      skip: false,
    },
  );

  const [createUser, responseCreateUser] = useCreateUserMutation();
  const [updateUser, responseUpdateUser] = useUpdateUserMutation();
  const [deleteUser, responseDeleteUser] = useDeleteUserMutation();
  const { data: merchantData, isLoading: isLoadingMerhchant } = useGetMerchantAllQuery();
  const {
    register, handleSubmit, control, watch, reset,
  } = useForm({
    defaultValues: { role: ROLES.ADMIN_ROLE, jv: [] },
  });

  const watchRole = watch('role', ROLES.ADMIN_ROLE);
  const {
    register: registerEdit,
    handleSubmit: handleSubmitEdit,
    control: controlEdit,
    setValue: setValueEdit,
    watch: watchEdit,
  } = useForm();

  const watchEditRole = watchEdit('editRole', ROLES.ADMIN_ROLE);

  const mapMerchantDataToSelector = () => {
    try {
      // ✅ เพิ่มเกราะป้องกันกรณี merchantData.data เป็น undefined
      const data = merchantData?.data || [];
      const merchantList = data.map((row, index) => ({
        index,
        ...row,
      }));
      setMerchants(merchantList);
    } catch (e) {
      console.error(e);
    }
  };

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    reset({
      email: '',
      role: ROLES.ADMIN_ROLE,
      jv: [],
    });
  };
  const handleCloseComp = () => setOpenComp(false);

  const [openEditModal, setOpenEditModal] = useState(false);
  const handleOpenEditModal = () => setOpenEditModal(true);
  const handleCloseEditModal = () => setOpenEditModal(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleRequestSort = (property) => {
    setSortOrder(
      sortBy === property && sortOrder === 'asc' ? 'desc' : 'asc',
    );
    setSortBy(property);
    setPage(0);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    if (!isLoadingMerhchant && merchantData) {
      mapMerchantDataToSelector();
    }
    return () => {};
  }, [merchantData]);

 const onSubmit = async (data) => {
  try {
    const { jv } = data;
    // ✅ เพิ่ม (jv || []) เพื่อป้องกัน jv เป็น undefined
    const sorgcode = (jv || []).map((item) => item?.sorgcode);
    const payload = data.role === ROLES.ADMIN_ROLE
      ? {
          email: data.email,
          role: data.role,
          sorgcode,
        }
      : {
          email: data.email,
          role: data.role,
        };

    const res = await createUser(payload);

    if (res.data && res.data.code === 201) {
      setTitle(t('app.addUserSuccess'));
      setNotiValue('success');
      setOpenNoti(true);
      handleClose();
      refetch();
    } 
    else {
      const apiErrorMessage = res.error?.data?.error?.message || res.error?.message; 
      setTitle(apiErrorMessage || t('app.failedAddUser'));
      setNotiValue('cancel');
      setOpenNoti(true);
      console.error('API Error Response:', res.error);
    }
  } catch (error) {
    console.error('Submit Error:', error);
    setTitle(t('app.failedAddUser'));
    setNotiValue('cancel');
    setOpenNoti(true);
  }
};

  const onSubmitEditUser = async (data) => {
    const { jv } = data;
    // ✅ เพิ่ม (jv || []) เพื่อป้องกัน jv เป็น undefined
    const sorgcode = (jv || []).map((item) => item?.sorgcode);
    try {
      const payload = data.editRole === ROLES.ADMIN_ROLE
        ? {
          params: { id: selectedEditId },
          body: {
            email: data.editEmail,
            role: data.editRole,
            sorgcode,
          },
        }
        : {
          params: { id: selectedEditId },
          body: {
            email: data.editEmail,
            role: data.editRole,
            sorgcode: '',
          },
        };
      const res = await updateUser(payload);
      if (res.data && res.data.code === 200) {
        setTitle('แก้ไขผู้ใช้สำเร็จ');
        setNotiValue('success');
        setOpenNoti(true);
        handleCloseEditModal();
        refetch();
      } else {
        setTitle('แก้ไขผู้ใช้ไม่สำเร็จ');
        setNotiValue('cancle');
        setOpenNoti(true);
        console.log(res.error);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const setEditDefaultValue = (data) => {
    setValueEdit('editEmail', data.email);
    setValueEdit('editRole', data.role);
    setSelectedEditId(data._id);
    setValueEdit('jv', data.jv);
  };

  const handleDeleteUser = async () => {
    const res = await deleteUser(id);

    if (res.data.statusCode === 200) {
      setOpenNotiComfirm(false);
      setTitle(t('app.deleteUserSuccess'));
      setNotiValue('success');
      setOpenNoti(true);
      refetch();
    } else {
      setOpenNotiComfirm(false);
      setTitle('ลบรายการไม่สำเร็จ');
      setNotiValue('cancel');
      setOpenNoti(true);
    }
  };

  const renderCreateUserForm = () => (
    <div>
      <div>{t('app.addUser')}</div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="py-6 px-4">
          <div>
            <TextField
              required
              fullWidth
              id="email"
              {...register('email', { required: true })}
              label={t('app.email')}
              type="email"
            />
          </div>
          <div className="py-4">
            <Controller
              render={({ field }) => (
                <FormControl fullWidth>
                  <InputLabel id="role-label">{t('app.role')}</InputLabel>
                  <Select
                    labelId="role-label"
                    label="บทบาท"
                    required
                    defaultValue={ROLES.ADMIN_ROLE}
                    onChange={(_, data) => field.onChange(data)}
                    {...field}
                  >
                    <MenuItem value={ROLES.ADMIN_ROLE}>
                      {ROLES.ADMIN_ROLE}
                    </MenuItem>
                    <MenuItem value={ROLES.SUPER_ADMIN_ROLE}>
                      {ROLES.SUPER_ADMIN_ROLE}
                    </MenuItem>
                    <MenuItem value={ROLES.SALE_ROLE}>
                      {ROLES.SALE_ROLE}
                    </MenuItem>
                  </Select>
                </FormControl>
              )}
              name="role"
              control={control}
            />
          </div>

          <div className="pt-4">
            {!isLoadingMerhchant && (
              <Controller
                defaultValue={[]}
                name="jv"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    {...field}
                    multiple
                    id="checkboxes-tags-demo"
                    options={merchants}
                    disableCloseOnSelect
                    onChange={(_, value) => {
                      field.onChange(value);
                    }}
                    hidden={watchRole === ROLES.SUPER_ADMIN_ROLE || watchRole === ROLES.SALE_ROLE}
                    getOptionLabel={(option) => option.merchant_name}
                    isOptionEqualToValue={(option, value) => option.sorgcode === value.sorgcode}
                    renderOption={(props, option, { selected }) => {
                      const { key, ...optionProps } = props;
                      return (
                        <li key={key} {...optionProps}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.merchant_name}
                        </li>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label={t('app.company')} />
                    )}
                  />
                )}
              />
            )}
          </div>
        </div>
        <div className="py-2 px-4 flex gap-1">
          {' '}
          <Button
            variant="contained"
            fullWidth
            sx={{ color: '#fff' }}
            onClick={() => {
              handleOpen();
            }}
            type="submit"
          >
          {t('app.add')}
          </Button>
          <Button
            variant="outlined"
            color="error"
            fullWidth
            onClick={() => {
              handleClose();
            }}
          >
         {t('app.cancel')}
          </Button>
        </div>
      </form>
    </div>
  );

  const renderEditUserForm = () => (
    <div>
      <div>{t('app.editUser')}</div>
      <form onSubmit={handleSubmitEdit(onSubmitEditUser)}>
        <div className="py-6 px-4">
          <div>
            <TextField
              required
              fullWidth
              id="email"
              {...registerEdit('editEmail', { required: true })}
              label={t('app.email')}
              type="email"
            />
          </div>
          <div className="py-4">
            <Controller
              render={({ field }) => (
                <FormControl fullWidth>
                  <InputLabel id="role-label">{t('app.role')}</InputLabel>
                  <Select
                    labelId="role-label"
                    label="บทบาท"
                    required
                    onChange={(_, data) => field.onChange(data)}
                    {...field}
                  >
                    <MenuItem value={ROLES.ADMIN_ROLE}>
                      {ROLES.ADMIN_ROLE}
                    </MenuItem>
                    <MenuItem value={ROLES.SUPER_ADMIN_ROLE}>
                      {ROLES.SUPER_ADMIN_ROLE}
                    </MenuItem>
                    <MenuItem value={ROLES.SALE_ROLE}>
                      {ROLES.SALE_ROLE}
                    </MenuItem>
                  </Select>
                </FormControl>
              )}
              name="editRole"
              control={controlEdit}
            />
          </div>

          <div className="pt-4">
            {!isLoadingMerhchant && (
              <Controller
                defaultValue={[]}
                name="jv"
                control={controlEdit}
                render={({ field }) => (
                  <Autocomplete
                    {...field}
                    multiple
                    hidden={watchEditRole === ROLES.SUPER_ADMIN_ROLE || watchEditRole === ROLES.SALE_ROLE}
                    id="checkboxes-tags-demo"
                    options={merchants}
                    disableCloseOnSelect
                    onChange={(_, value) => {
                      field.onChange(value);
                    }}
                    getOptionLabel={(option) => option.merchant_name}
                    isOptionEqualToValue={(option, value) => option.sorgcode === value.sorgcode}
                    renderOption={(props, option, { selected }) => {
                      const { key, ...optionProps } = props;
                      return (
                        <li key={key} {...optionProps}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.merchant_name}
                        </li>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t('app.company')}
                      />
                    )}
                  />
                )}
              />
            )}
          </div>
        </div>
        <div className="py-2 px-4 flex gap-1">
          {' '}
          <Button
            variant="contained"
            fullWidth
            sx={{ color: '#fff' }}
            type="submit"
          >
           {t('app.edit')}
          </Button>
          <Button
            variant="outlined"
            color="error"
            fullWidth
            onClick={() => {
              handleCloseEditModal();
            }}
          >
            {t('app.cancel')}
          </Button>
        </div>
      </form>
    </div>
  );

  const handleNotiClose = () => {
    setOpenNoti(false);
    setTitle('');
    setNotiValue('');
  };

  return (
    <div>
      <TransitionsModal open={open} setOpen={setOpen}>
        {renderCreateUserForm()}
      </TransitionsModal>
      <TransitionsModal open={openEditModal} setOpen={setOpenEditModal}>
        {renderEditUserForm()}
      </TransitionsModal>
      <div className="hidden md:flex text-lg font-bold  items-center justify-between py-2">
      {t('app.userManagement' )}
      </div>
      <div className="flex flex-wrap justify-between ">
        <Paper
          component="form"
          sx={{
            p: '2px 4px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <InputBase
            fullWidth
            sx={{ ml: 1, flex: 1 }}
            placeholder={t('app.search')}
            onChange={(e) => {
              if (userLists) {
                setSearch(e.target.value);
              }
            }}
          />
          <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
          <Box color="primary" sx={{ p: '10px' }}>
            <SearchIcon sx={{ fontSize: '22px' }} color="primary" />
          </Box>
        </Paper>
        <div className="w-full md:w-1/3 flex justify-end">
          <div className="py-2 ">
            {' '}
            <Button
              variant="contained"
              sx={{ color: '#fff' }}
              onClick={() => {
                handleOpen();
              }}
              startIcon={<ModeEdit />}
            >
              เพิ่มผู้ใช้งาน
            </Button>
          </div>
        </div>
      </div>
      <div className="py-4">
        {!isLoading && (
          <Paper sx={{ width: '100%', overflow: 'hidden' }}>
          <TableContainer sx={{ overflowX: 'auto', overflowY: 'visible' }}>

              <Table size='small'>
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        sx={{ backgroundColor: 'primary.main', color: '#fff' }}
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                      >
                        <SortableTableLabel
                          column={column}
                          sortBy={sortBy}
                          sortOrder={sortOrder}
                          onSort={handleRequestSort}
                          color="white"
                        />
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* ✅ เติม ? หลัง data เพื่อป้องกัน Error undefined */}
                  {!isLoading
                    && userLists?.data?.map((row, index) => (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row._id}
                      >
                        {columns.map((column) => {
                          const value = row[column.id];
                          if (column.id === 'order') {
                            return (
                              <TableCell key={column.id} align={column.align}>
                                {index + 1}
                              </TableCell>
                            );
                          }

                          if (column.id === 'sorgcode') {
                            return (
                              <TableCell key={column.id} align={column.align}>
                                {value || '-'}
                              </TableCell>
                            );
                          }
                          // เช็คสิทธิ์ในตารางเพื่อไม่ให้ปุ่มดูบริษัทโชว์ขึ้นมาสำหรับ SALES
                         // ---------------- แทนที่โค้ดเดิมด้วยชุดนี้ ----------------
                          if (column.id === 'company') {
                            // 1. ถ้าเป็น SUPER ADMIN หรือ SALE ให้แสดงข้อความ "-" หรือ "All"
                            if (
                              row.role === ROLES.SUPER_ADMIN_ROLE ||
                              row.role === ROLES.SALE_ROLE
                            ) {
                              return (
                                <TableCell key={column.id} align={column.align}>
                                  <span className="text-gray-500 font-semibold">All</span>
                                </TableCell>
                              );
                            }

                            // 2. ถ้าเป็น ADMIN ธรรมดา ให้แสดงปุ่มดูรายชื่อบริษัท
                            return (
                              <TableCell key={column.id} align={column.align}>
                                <Button
                                  variant="contained"
                                  sx={{ color: '#fff' }}
                                  onClick={() => {
                                    setOpenComp(true);
                                    setCompList(row.merchant_name);
                                  }}
                                >
                                  {/* หมายเหตุ: แก้จาก sorgcode[0].length เป็น sorgcode.length เพื่อให้แสดง "จำนวน" บริษัทที่เลือกได้ถูกต้อง */}
                                  {row.sorgcode?.length || 0}
                                </Button>
                              </TableCell>
                            );
                          
                          // -------------------------------------------------------- {
                            return (
                              <TableCell key={column.id} align={column.align}>
                                <Button
                                  variant="contained"
                                  sx={{ color: '#fff' }}
                                  onClick={() => {
                                    setOpenComp(true);
                                    setCompList(row.merchant_name);
                                  }}
                                >
                                  {row.sorgcode?.[0]?.length || 0}
                                </Button>
                              </TableCell>
                            );
                          }

                          if (column.id === 'action') {
                            return (
                              <TableCell key={column.id} align={column.align}>
                                <IconButton
                                  color="primary"
                                  onClick={() => {
                                    setEditDefaultValue(row);
                                    handleOpenEditModal();
                                  }}
                                >
                                  <ModeEdit />
                                </IconButton>
                                <IconButton
                                  color="error"
                                  onClick={() => {
                                    setId(row._id);
                                    setOpenNotiComfirm(true);
                                  }}
                                >
                                  <Delete />
                                </IconButton>
                              </TableCell>
                            );
                          }
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={!isLoading && userLists?.pagination ? userLists.pagination.total : 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        )}
      </div>
      <NotiAlert
        open={openNoti}
        setOpe={setOpenNoti}
        title={title}
        onButtonClick={handleNotiClose}
        value={notiValue}
      />
      <NotiAlertComfirmManageDel
      t={t}
        open={openNotiComfirm}
        setOpen={setOpenNotiComfirm}
        handleDeleteUser={handleDeleteUser}
        setId={setId}
      />
      <NotiAlertShowComp
        open={openComp}
        handleCloseComp={handleCloseComp}
        compList={compList}
      />
    </div>
  );
}
